"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomXPFieldRenderer = void 0;
const react_1 = __importDefault(require("react"));
const Renderer_1 = require("@kyruus/rich-text/Renderer");
const card_container_1 = __importDefault(require("../CardContainer/card-container"));
const utils_1 = require("../../lib/utils");
const provider_about_styles_1 = require("../ProviderAbout/provider-about.styles");
const styles_1 = require("./styles");
const CustomXPFieldRenderer = ({ customXPFieldConfig, provider }) => {
    const content = (0, utils_1.extractProviderDataContent)({ field: customXPFieldConfig.field }, provider);
    if (content) {
        return (react_1.default.createElement(card_container_1.default, null,
            react_1.default.createElement(styles_1.CustomXPFieldsHeader, null, customXPFieldConfig.title),
            react_1.default.createElement(styles_1.CustomXPFieldsContent, null,
                react_1.default.createElement(provider_about_styles_1.AboutContentText, { content: content.toString(), "data-testid": `custom-xp-field-${customXPFieldConfig.field}-content`, disableDefaultMatchers: true, matchers: [new Renderer_1.UrlMatcher('url')], newWindow: true, tagName: customXPFieldConfig.field_type === 'rich_text' ? 'div' : 'p' }))));
    }
    return null;
};
exports.CustomXPFieldRenderer = CustomXPFieldRenderer;
//# sourceMappingURL=custom-xp-field-renderer.js.map